import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../../hooks/hooks";

import PageLoader from "../../../../../../../components/PageLoader";
import Table from "../../../../../../../common/components/table";
import { selectPolicyCollectionsListItems } from "../../../../../../../redux/organization/collections/selector";
import { policyCollections } from "../../../../../../../redux/organization/collections/action";

const CategoryCollectionInfoComponent = ({globalOrgRegistryId,accountId}: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const policyItems = useSelector(selectPolicyCollectionsListItems);
  const [columnDefs, setColumnDefs] = useState([]);

  // Column Definitions
  const createColumnDefs = () => {
    setColumnDefs([
      {
        field: "Sl",
        sortable: false,
        filter: false,
        headerName: "Sl",
        cellRenderer: (params: any) => parseInt(params.node.id, 10) + 1,
      },
      {
            field: 'Image',
        headerName: 'Image',
        sortable: false,
        filter: false,
        cellRenderer: 'imageRenderer',
        filterType: 'text',
      },
      { field: "CollectionName", headerName: "Collection Name", sortable: true, filter: true },
      { field: "ProductName", headerName: "Category Name", sortable: true, filter: true },
      { field: "ProductCode", headerName: "Category Code", sortable: true, filter: true },
      { field: "Ratings", headerName: "Ratings", sortable: true },
    ]);
  };
  useEffect(() => {
    console.log("Fetched policyItems:", policyItems);
  }, [policyItems]);
  const formatRowData = () => {
    if (!Array.isArray(policyItems?.result?.items)) {
      return [];
    }
  
    return policyItems?.result?.items.flatMap((item: any, itemIndex: number) => {
      return item.Collections?.map((collection: any, collectionIndex: number) => {
        if (!collection?.EntityInfo?.EntityId ) {
          return [];
        } 
          return {
            Id: collection?.Id,
            CollectionName: collection?.EntityInfo?.EntityName || "",
            ProductName: collection?.EntityInfo?.EntityName || "",
            Price: collection?.EntityInfo?.Price || "",
            ProductCode: collection?.EntityInfo?.CategoryCode || "",
            Ratings: collection?.Evaluation?.Ratings?.Rates || 0,
            Image: collection?.MediaMappings?.MediaFiles?.[0]?.FileMappingURL || "",
          };
       
      }) || [];
    });
  };
  
  
    

  // Fetch Product Collections
  const fetchProductCollections = async () => {
    await dispatch(policyCollections.resetAction({ actionType: "list" }));
    const config = {
      Context: {},
      Records: [
        {
          CollectionTypeId: 4,
          GlobalOrgRegistryId: globalOrgRegistryId,
        },
      ],
      Pagination: {
        PageNumber: 1,
        PageSize: 100,
        SortField: "DisplayOrder",
        SortOrder: "desc",
      },
    };

    await dispatch(
      policyCollections.list({
        url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/organization/csp/collections/fetch-resultant-policy`,
        entity: "policyCollections",
        jsonData: config, options:{key: `vendor-${accountId}-product-collection`}
      })
    );
  };

  // Handle Search
  const handleSearch = async (data: any) => {
    console.log("Search data", data);
    const searchCriteria = [
      {
        FieldName: data?.column || "Name",
        FieldText: data?.column || "Name",
        FieldType: "text",
        FilterOperatorId: 6,
        FieldValue: data?.value,
      },
    ];

    const config = {
      Context: {},
      Records: [
        {
          CollectionTypeId: 4,
          GlobalOrgRegistryId: globalOrgRegistryId,
        },
      ],
      Pagination: {
        PageNumber: 1,
        PageSize: 100,
        SortField: "DisplayOrder",
        SortOrder: "desc",
      },
    };

    await dispatch(
      policyCollections.list({
        url: `https://policy.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/policy/organization/csp/collections/fetch-resultant-policy`,
        entity: "policyCollections",
        jsonData: config, options:{key: `vendor-${accountId}-product-collection`}
      })
    );
  };

  useEffect(() => {
    createColumnDefs();
    fetchProductCollections();
  }, [pageData, pageSize]);

  return (
    <>
      {policyItems?.isLoading ? (
        <PageLoader />
      ) : (
        <Table
          columnData={columnDefs}
          onSearch={handleSearch}
          rowData={formatRowData()}
          setPageData={setPageData}
          paginationData={policyItems?.result?.pagination}
          setPageSize={setPageSize}
          headingName="category Collections"
        />
      )}
    </>
  );
};

export default CategoryCollectionInfoComponent;
